import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import AppPaths from '../../AppPaths';
import { ReactComponent as ArrowLeftIcon } from '../../assets/images/icons/arrow_left.svg';
import { ReactComponent as CloseIcon } from '../../assets/images/icons/close.svg';
import styles from './HardwareFirstCartHeader.module.scss';

/**
 * The hardware-first cart's page title. Mobile pins a white bar with a dismiss control, desktop
 * reads as a back link; both return to the shop. Going back through history instead would land on
 * whatever preceded the cart - a stale url, a pdp, or the checkout - rather than somewhere to keep
 * shopping. `/shop` redirects anyone outside the arm to `/products`, so this is safe either way.
 */
export default function HardwareFirstCartHeader() {
  const { t } = useTranslation();
  const history = useHistory();

  const leaveCart = () => history.push(AppPaths.Shop);

  return (
    <>
      <div className={styles.mobileHeader}>
        <h1 className={styles.mobileTitle}>{t('cart')}</h1>
        <button aria-label={t('close')} className={styles.close} onClick={leaveCart} type="button">
          <CloseIcon />
        </button>
      </div>
      <div className={styles.desktopHeaderRow}>
        <button className={styles.desktopHeader} onClick={leaveCart} type="button">
          <ArrowLeftIcon className={styles.backArrow} />
          <span className={styles.desktopTitle}>{t('cart')}</span>
        </button>
      </div>
    </>
  );
}
